import React from "react"
import { Container, Row, Col } from "reactstrap"
import FooterMenu from "./FooterMenu"

const FooterMenus = () => {
    return (
			<Container className="text-center auto">
				<Row className="justify-content-center text-center">
					<Col lg={10}>
						<Row>
							<Col xs={20} md={4}>
								<FooterMenu menu={1} />
							</Col>
							<Col xs={20} md={4}>
								<FooterMenu menu={2} />
							</Col>
							<div className="w-100 d-md-none" />
							<Col xs={20} md={4}>
								<FooterMenu menu={3} />
							</Col>
						</Row>
					</Col>
				</Row>
			</Container>
    )
}

export default FooterMenus